module.exports = __webpack_public_path__ + "static/media/500005.8b3cdbb0.svg";